import { render, staticRenderFns } from "./CarMainBasicInfoData.vue?vue&type=template&id=acec30d4"
import script from "./CarMainBasicInfoData.vue?vue&type=script&lang=js"
export * from "./CarMainBasicInfoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports